import React from "react";
import App from "./router";
import AppNavigation from "./framework/navigation";
import AppFooter from "./framework/footer";
import { colors } from "./theme/brand";

export default function AppMain() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: colors.cream, color: colors.ink }}>
      <AppNavigation />
      <main style={{ flex: 1 }}>
        <App />
      </main>
      <AppFooter />
    </div>
  );
}
